import HorizonExaminedHistory from './HorizonExaminedHistory';

export default class ExaminedHistoryChanges {
    adds: Array<HorizonExaminedHistory>;
    updates: Array<HorizonExaminedHistory>;
    deleteIds: Array<number>;

    constructor() {
        this.adds = [];
        this.updates = [];
        this.deleteIds = [];
    }
}



// WEBPACK FOOTER //
// ./src/models/tract_detail/ExaminedHistoryChanges.ts